import { useEffect, useState } from 'react';
import {
  chooseProvider,
  closeProviderPicker,
  subscribeProviderPicker,
} from './authCompat';
import { BETTER_AUTH_ENABLED } from './betterAuthFlag';

// Better Auth has no hosted login page: this modal is what a bare
// loginWithRedirect() opens so the player can pick a provider.
const PROVIDERS = [
  { id: 'twitch', label: 'Continue with Twitch', className: 'btn btn-primary btn-block' },
  { id: 'kick', label: 'Continue with Kick', className: 'btn btn-success btn-block' },
  { id: 'google', label: 'Continue with Google / YouTube', className: 'btn btn-light btn-block' },
];

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2000,
};

const cardStyle = {
  background: '#1c1c24',
  color: '#fff',
  borderRadius: '8px',
  padding: '24px',
  width: '320px',
  maxWidth: '90vw',
  textAlign: 'center',
};

const ProviderPickerModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => subscribeProviderPicker(setOpen), []);

  if (!BETTER_AUTH_ENABLED || !open) return null;

  return (
    <div
      style={overlayStyle}
      role="presentation"
      onClick={(e) => {
        // only a click on the backdrop itself dismisses (keeps the card
        // click-handler-free for jsx-a11y)
        if (e.target === e.currentTarget) closeProviderPicker();
      }}
    >
      <div style={cardStyle} role="dialog" aria-label="Sign in">
        <h4 className="mb-3">Sign in to RNG Royale</h4>
        <div className="d-flex flex-column gap-2">
          {PROVIDERS.map((p) => (
            <button
              key={p.id}
              type="button"
              className={p.className}
              onClick={() => chooseProvider(p.id)}
            >
              {p.label}
            </button>
          ))}
          <button
            type="button"
            className="btn btn-outline-secondary btn-block"
            onClick={closeProviderPicker}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProviderPickerModal;
